module.exports = __webpack_public_path__ + "static/media/27OCHA18.6ea12eed.jpg";